module.exports = __webpack_public_path__ + "img/hunlizhuchi.6882013b.png";